<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.branche_id != null}">
                                        <label for="branche_id" class="bmd-label-floating">Loja</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="branches"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.branche_id">
                                        </model-list-select>
                                        <label v-if="validation.branche_id != null" id="branch_id-error" class="error" for="branche_id">{{ validation.branch_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Criação do Lead</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            :not-after="form.end_at"
                                            >
                                        </date-picker>
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.sale_at != null}">
                                        <label for="sale_at" class="bmd-label-floating">Intervalo para data da Venda</label>
                                        <date-picker
                                            range
                                            v-model="form.sale_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            :not-after="form.sale_end_at"
                                            >
                                        </date-picker>
                                    </div>
                                 </div>
                               </div>
                            <div class="row">
                            <div class="col-md-4">
                                <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.administrator_id != null}">
                                    <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                    <model-list-select 
                                        class="form-control"
                                        :list="administrators"     
                                        option-value="id"
                                        option-text="name"
                                        v-model="form.administrator_id">
                                    </model-list-select>
                                    <label v-if="validation.administrator_id != null" id="administrator_id-error" class="error" for="administrator_id">{{ validation.administrator_id }}</label>
                                </div>
                            </div>
                        
                          
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="teams"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.team_id"
                                            @input="handlerChangeTeams"    
                                        >
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Vendedor</label>
                                        <model-list-select
                                                class="form-control"
                                                :list="responsibles"
                                                option-value="id"
                                                option-text="name"
                                                v-model="form.responsible_id">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            typesCommissions: {
                get() {
                    return this.$store.state.commissions.typeOfCommissions
                }
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            },
            responsibles: {
                set(_items) {
                    this.$store.commit("users/setList", _items);
                },
                get() {
                    return this.$store.state.users.itens;
                }
            }
        },
        data() {
            return {
                 validation: {
                    date_at: null,
                     responsible_id: null,
                     team_id: null,
                     administrator_id : null,
                     branche_id: null,

                },
                form: {
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                    date_at: '', 
                    end_at: '', 
                    sale_at: '', 
                    sale_end_at: '' 
                },
                referenceDates: [
                    { id : 'sale_date', name : 'Data da Venda'},
                    { id : 'due_date' , name : 'Data de Vencimento'},
                    { id : 'payday'   , name : 'Data de Pagamento'},
                ],
            };
        },
        methods: {
            handlerChangeTeams(team_id) {
                this.form.responsible_id = null;
                const data = this.getUsers('team_id='+team_id);
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                //self.getData();
                 const response = self.$store.dispatch('administrators/all');
                
                //
                 response.then(function () {
                     self.$root.$emit("onLoading");
                     self.getData();
                 });
                //
                 response.catch(function () {
                     self.$root.$emit("onLoading");
                 });
            },
            async getData() {
                 var self = this;
                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('commissions/typesOfcommissions');
                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataTeams();
                });
            },
            onReset() {
                this.form = {
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment().add(40, 'days'),
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    date_at: null,
                    responsible_id: null,
                    team_id: null,
                    administrator_id : null,
                    branche_id: null,

                };

                // if (!self.form.installment) {
                //     valid = false;
                //     self.validation.installment = 'Favor informar a administradora desejada!';
                // }

                if (valid) {
                    var serialize = JSON.stringify(self.form);
                    
                    window.open("print-lead-conversion?form=" + serialize, '_blank');
                }
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getUsers();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getUsers();
                });
            },
            async getUsers(_param) {
                var self = this;

                self.$root.$emit('onLoading');

                const response =  self.$store.dispatch('users/all', _param);
                
                response.then(function (x) {
                    self.responsibles = x;
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
        },
        created() {
            var self = this;
            self.getDataAdministrators();
        }
    }
</script>
